import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { api } from '../lib/api';
import Header from '../components/Header';
import { Button } from '../components/ui/button';
import { UserRound, KeyRound } from 'lucide-react';
import { AuthField, errText } from '../components/AuthBits';

export default function ForgotPassword() {
  const nav = useNavigate();
  const [identifier, setIdentifier] = useState('');
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const isPhone = identifier && !identifier.includes('@');

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await api.post('/auth/forgot-password', { identifier: identifier.trim() }); setSent(true); }
    catch (err) { toast.error(errText(err) || 'Erreur'); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen">
      <Header />
      <div className="max-w-md mx-auto px-4 py-14">
        <div className="card-elev rounded-3xl p-7">
          <h1 className="font-display text-3xl font-extrabold flex items-center gap-2"><KeyRound className="h-7 w-7 text-sky-400" />Mot de passe oublié</h1>
          {!sent ? (
            <form onSubmit={submit} className="mt-6 space-y-3">
              <p className="text-sm text-slate-400">Entrez votre e-mail ou votre numéro de téléphone. Vous recevrez un lien par e-mail ou un code par SMS.</p>
              <AuthField icon={<UserRound className="h-4 w-4" />} type="text" value={identifier} onChange={setIdentifier} placeholder="E-mail ou téléphone" testid="forgot-identifier" />
              <Button disabled={busy || !identifier} type="submit" data-testid="forgot-submit" className="w-full btn-brand text-white py-6 rounded-xl font-bold">Envoyer</Button>
            </form>
          ) : (
            <div className="mt-6 space-y-4" data-testid="forgot-sent">
              <div className="p-4 rounded-xl bg-emerald-500/10 border border-emerald-500/40 text-emerald-200 text-sm">
                Si ce compte existe, {isPhone ? 'un code à 6 chiffres vous a été envoyé par SMS.' : 'un lien de réinitialisation vous a été envoyé par e-mail (vérifiez aussi les spams).'}
              </div>
              {isPhone && <Button data-testid="forgot-enter-code" onClick={() => nav(`/reset-password?identifier=${encodeURIComponent(identifier.trim())}`)} className="w-full btn-brand text-white py-5 rounded-xl font-bold">J'ai reçu mon code</Button>}
            </div>
          )}
          <div className="mt-6 text-center text-sm text-slate-400">
            <Link to="/login" data-testid="back-to-login" className="text-sky-400 hover:underline">Retour à la connexion</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
